import { Breadcrumbs, Link } from '@mui/material';
import { useMatches, useNavigate } from 'react-router-dom';
import { ReactElement } from 'react';
import { Typography } from './typography';

export interface BreadcrumbStep {
  path: string;
  name: string;
}

export const Breadcrumb = (): ReactElement => {
  const navigate = useNavigate();

  let matches = useMatches();
  let crumbs = matches
    //@ts-ignore
    .filter((match) => Boolean(match.handle?.crumb))
    //@ts-ignore
    .map((match) => match.handle.crumb(match.data)) as BreadcrumbStep[];

  return (
    <Breadcrumbs sx={{ ml: '20px' }}>
      {crumbs.map((el, idx) => (
        <Link
          key={el.path}
          sx={{ display: 'flex', alignItems: 'center' }}
          underline={idx === crumbs.length - 1 ? 'none' : 'hover'}
          color={idx === crumbs.length - 1 ? 'primary.main' : 'secondary.main'}
          onClick={() => {
            idx !== crumbs.length - 1 && navigate(el.path);
          }}
        >
          {idx === crumbs.length - 1 ? (
            <Typography truncate maxWidth={'800px'} fontSize={'18px'}>
              {el.name}
            </Typography>
          ) : (
            <Typography fontSize={'16px'} color="inherit">
              {el.name}
            </Typography>
          )}
        </Link>
      ))}
    </Breadcrumbs>
  );
};
